/**
 * These are all runtime dependencies. Any breaking changes
 * will need a migration path first!
 */
const prefix = 'urn';
const namespace = 'sfextslot';
const owner = 'client-dashboard-pilet';
export const clientDashboardExtensionSlots = {
    drawerCommentsTab: `${prefix}:${namespace}:${owner}:drawer:comments:tab`,
    drawerCommentsContent: `${prefix}:${namespace}:${owner}:drawer:comments:content`,
    drawerAttachmentsContent: `${prefix}:${namespace}:${owner}:drawer:attachments:content`,
};
//# sourceMappingURL=extensionTypes.js.map